import { css } from '@emotion/react';

export const pages = [];

const linkStyleIndented = css`
  margin-left: 1.25rem !important;
`;

pages.push({
  linkName: 'Roster',
  link: '/team',
  childLinks: [
    {
      linkName: 'Managers',
      link: '/team/current/managers',
      hidden: true,
    },
    {
      linkName: 'Staff',
      link: '/team/current/staff',
      hidden: false,
    },
    {
      linkName: 'Legacy Seasons',
      link: '/team/2023-2024/',
      hidden: false,
    },
  ]
});

pages.push({
  linkName: 'Shop',
  link: '/shop',
  hidden: false,
  /*
  childLinks: [
    {
      linkName: 'Apparel',
      link: '/shop/apparel',
      hidden: false
    },
    {
      linkName: 'Uniforms',
      link: '/shop/uniforms',
      hidden: true
    },
    {
      linkName: 'Uniforms (8U)',
      link: '/shop/uniforms-8u-only',
      hidden: true
    }
  ],*/
});

const resources = {
  linkName: 'Resources',
  childLinkStyling: css`
      left: -50px;
      width: 18rem;
    `,
};

const resourcesChildLinks = [
  {
    categoryName: `Tuition`,
    hidden: true
  },
  {
    linkName: '10U Squirt',
    link: '/tuition2026/tuition/202610UTUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: '12UA (Josh)',
    link: '/tuition2026/tuition/202612UATUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: '12UAA (Cole/Ray)',
    link: '/tuition2026/tuition/202612UAATUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: '14U (Smith)',
    link: '/tuition2026/tuition/202614UTUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: '16U (Lutheran)',
    link: '/tuition2026/tuition/202616UTUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: '18U (Chafe)',
    link: '/tuition2026/tuition/202618UTUITION',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    categoryName: 'Tryouts',
    hidden: true
  }, 
  {
    linkName: `Bulldogs '26-'27`,
    link: '/teamTryouts/teamTryout2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Bulldogs+Yetis '26-'27`,
    link: '/teamTryouts/yetisBulldogsTryout2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Bulldogs '25-'26`,
    link: '/teamTryouts/teamTryout2025',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    categoryName: 'Clinics',
    hidden: true
  },
  {
    linkName: `Girls Small Group Lessons`,
    link: '/teamClinics/girlssmallgroup2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Small Group Lessons`,
    link: '/teamClinics/smallgroup2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Full Season Development`,
    link: '/teamClinics/fullseason2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Skills+Drills Elite U12 U14`,
    link: '/teamClinics/skillsdrillsu12u14elite2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Skills+Drills U16/U18`,
    link: '/teamClinics/skillsdrillsU16U182026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Summer Hockey Camp`,
    link: '/teamClinics/shawnraysummerhockeycamp2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Summer Hockey Elite Camp`,
    link: '/teamClinics/shawnraysummerhockeycampelite2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    linkName: `Girls NCAA Exposure Camp`,
    link: '/teamClinics/girlsncaacollegecamp2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    categoryName: 'Tournaments',
    hidden: false
  },
  {
    linkName: 'U14AA Corey Smith',
    link: '/tournaments/tournaments202614UAA',
    linkStyle: linkStyleIndented,
    hidden: false
  },
  {
    linkName: 'U16 Adam Lutheran',
    link: '/tournaments/tournaments202616U',
    linkStyle: linkStyleIndented,
    hidden: false
  },
  {
    linkName: 'Quebec 2026',
    link: '/tournaments/quebec2026',
    linkStyle: linkStyleIndented,
    hidden: true,
  },
  {
    linkName: 'Multi-division Tournaments',
    link: '/tournaments/tournaments2026',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    categoryName: 'Events/Misc',
    hidden: true
  },
  {
    linkName: 'Mites Travel Deposit',
    link: '/teamEvents/mitestraveldeposit2024',
    linkStyle: linkStyleIndented,
    hidden: true
  },
  {
    categoryName: 'Team Info'
  },
  {
    linkName: 'Pee-Wee Quebec',
    link: '/quebec2026/info',
    linkStyle: linkStyleIndented,
    // requireAuth: true,
    // requireAdmin: true,
  },
  {
    linkName: 'Yetis - Elite',
    link: '/yetis-elite-2026/info',
    linkStyle: linkStyleIndented,
    // requireAuth: true,
    // requireAdmin: true,
  },
  /**
   * The team is no longer using Teamsnap under the proper structure - schedules are no longer going to sync, disabling them as of 07/13/2026.
  {
    linkName: 'Schedule',
    link: '/schedule/allteams/game/allopponents/allseasons/alllocations',
    linkStyle: linkStyleIndented
  },
    */
  {
    linkName: 'Team Documents',
    link: '/teamDocuments',
    requireAuth: true,
    linkStyle: linkStyleIndented
  }
];

// shows how we add links available for local dev work
/**
 * 
 * 
function addObjectAfterCondition({ arr, newObject, conditionValue }) {
  // Flag to see if we have added the object
  let objectAdded = false;
  // Iterate through the array to find the matching condition
  for (let i = 0; i < arr.length; i++) {
    // Check for condition match
    if (arr[i].categoryName === conditionValue || arr[i].link === conditionValue) {
      // Insert newObject right after the current element
      arr.splice(i + 1, 0, newObject);
      objectAdded = true;
      break; // Exit the loop once the object is added
    }
  }
  // If no matching condition was found, you could handle it here
  // For example, you could push the object to the end of the array
  if (!objectAdded) {
    console.warn('Condition value not found. Object not added.');
  }
  return arr; // Return the modified array
}
  
if (process.env.NODE_ENV === 'development') {
  addObjectAfterCondition({
    arr: resourcesChildLinks,
    newObject:
    {
      linkName: '18U - DEV ONLY',
      link: '/tuition2024/tuition/202416UTUITION',
      linkStyle: linkStyleIndented,
      hidden: false
    },
    conditionValue: '/tuition2024/tuition/202416UTUITION'
  }
  );
  addObjectAfterCondition({
    arr: resourcesChildLinks,
    newObject:
    {
      linkName: 'TEST LINK Dev Only',
      link: '/schedule/allteams/game/allopponents/allseasons/alllocations',
      linkStyle: linkStyleIndented,
      hidden: false
    },
    conditionValue: 'Team Info'
  }
  );
}
 */
resources.childLinks = resourcesChildLinks;
pages.push(resources);


pages.push({
  linkName: 'News',
  link: '/news'
});

pages.push({
  linkName: 'About',
  link: '/about',
  childLinks: [
    {
      linkName: 'About Us',
      link: '/about'
    },
    {
      categoryName: 'Media'
    },
    {
      linkName: 'USA Hockey',
      link: 'https://www.usahockey.com/',
      linkStyle: linkStyleIndented
    },
    {
      linkName: 'Sahof',
      link: 'https://www.sahofhockey.org/',
      linkStyle: linkStyleIndented
    },
  ]
});

pages.push({
  linkName: 'Log in',
  linkNameSignedIn: 'Account',
  link: '/account',
  childLinkStyling: css`
    left: -100px;
  `,
  childLinks: [
    {
      linkName: 'Sign In',
      link: '/signin',
      hideWithAuth: true,
      requireAuth: false
    },
    {
      linkName: 'Sign Up',
      link: '/signup',
      hideWithAuth: true,
      requireAuth: false
    },
    {
      linkName: 'Account',
      link: '/account',
      requireAuth: true
    },
    {
      linkName: 'Registrations',
      link: '/registrations',
      requireAuth: true,
      hidden: true
    },
    {
      linkName: 'Tuition',
      link: '/tuition',
      requireAuth: true,
      hidden: false
    },
    {
      linkName: 'Tournaments',
      link: '/tournaments',
      requireAuth: true
    },
    {
      linkName: 'Clinics',
      link: '/teamClinics',
      requireAuth: true
    },
    {
      linkName: 'Events',
      link: '/teamEvents',
      requireAuth: true
    },
    {
      linkName: 'Tryouts',
      link: '/teamTryouts',
      requireAuth: true,
      hidden: false
    },
    {
      linkName: 'Orders',
      link: '/orders',
      requireAuth: true
    },
    {
      categoryName: 'Admin',
      requireAuth: true,
      requireAdmin: true,
      requireOrders: true,
      requireEvents: true,
      requireClinics: true,
      requireTuition: true,
      requireTryouts: true,
      requireTournaments: true,
      staffLink: true
    },
    {
      linkName: 'Team Registrations',
      link: '/registrationsAdmin',
      hidden: true,
      requireAuth: true,
      requireAdmin: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Tuition',
      link: '/tuitionAdmin',
      requireAuth: true,
      requireTuition: true,
      linkStyle: linkStyleIndented,
      hidden: false,
      staffLink: true
    },
    {
      linkName: 'Tournaments',
      link: '/tournamentsAdmin',
      requireAuth: true,
      requireTournaments: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Events',
      link: '/teamEventsAdmin',
      requireAuth: true,
      requireEvents: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Tryouts',
      link: '/teamTryoutsAdmin',
      requireAuth: true,
      requireTryouts: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Clinics',
      link: '/teamClinicsAdmin',
      requireAuth: true,
      requireClinics: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Orders',
      link: '/ordersAdmin',
      requireAuth: true,
      requireOrders: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Users',
      link: '/users',
      requireAuth: true,
      requireAdmin: true,
      linkStyle: linkStyleIndented,
      staffLink: true
    },
    {
      linkName: 'Sign Out',
      link: '/signout',
      requireAuth: true
    }
  ]
});

export default pages;
